import axios from "axios";
import moment from "moment";
import React, { useEffect } from "react";
import DatePicker from "../../Components/DatePicker/DatePicker";
import Dropdown from "../../Components/Dropdown/Dropdown";
import RadioButtonGroup from "../../Components/RadioButtonGroup/RadioButtonGroup";
import { Button } from "../../Components/StyledComponents";
import { convertCost } from "../../Utils/functions";
import './Vat.scss';

const typeList = { 'manual': '날짜 직접 선택', 'quarter': '분기 선택', 'recent': '최근 일자 선택' }

const Vat = () => {
    const [type, setType] = React.useState('recent')//기간 필터 기준 선택
    const [startDate, setStartDate] = React.useState(new Date())//조회 시작 날짜
    const [endDate, setEndDate] = React.useState(new Date())//조회 종료 날짜
    const [quarter, setQuarter] = React.useState(1)//분기 선택
    const [recent, setRecent] = React.useState(2)//최근 일자 선택
    const [year, setYear] = React.useState('2024')//분기 연도 선택
    const [vat, setVat] = React.useState(0)//부가세 금액

    useEffect(() => {
        search()
    }, [])

    //분기 최대값 설정
    const handleQuarter = (value) => {
        if (moment(new Date()).year() === Number(year)) {
            let checkMonth = (moment(new Date()).month() + 1)
            if (checkMonth >= 7 && checkMonth < 10 && value > 3) setQuarter(3)
            else if (checkMonth >= 4 && checkMonth < 7 && value > 2) setQuarter(2)
            else if (checkMonth < 4 && value > 1) setQuarter(1)
            else setQuarter(value)
        } else {
            setQuarter(value)
        }
    }

    //부가세 정보 Get
    const search = () => {
        if (type === 'manual') {
            let start_date = moment(startDate).format('YYYYMMDD')
            let end_date = moment(endDate).format('YYYYMMDD')
            axios.get(`/api/vat?type=manual&start_date=${start_date}&end_date=${end_date}`)
                .then((data) => {
                    setVat(data.data.PaymentPrice)
                })
        } else if (type === 'quarter') {
            axios.get(`/api/vat?type=quarter&year=${year}&query=${quarter}`)
                .then((data) => {
                    setVat(data.data.PaymentPrice)
                })
        } else {
            axios.get(`/api/vat?type=recent&query=${recent}`)
                .then((data) => {
                    setVat(data.data.PaymentPrice)
                })
        }
    }

    //날짜 직접 선택 render
    const renderDate = () => {
        return (
            <div className="row" style={{ marginLeft: 24 }}>
                <DatePicker value={startDate} onChange={(date) => { setStartDate(date); setType('manual'); }} style={{ width: 160 }} />
                <p className="tilde">~</p>
                <DatePicker value={endDate} minDate={startDate} onChange={(date) => { setEndDate(date); setType('manual'); }} style={{ width: 160 }} />
            </div>
        )
    }

    //분기 선택 Render
    const renderQuarter = () => {
        return (
            <div className="row" style={{ marginLeft: 24, alignItems: 'center' }}>
                <Dropdown
                    options={[
                        { key: '년도선택', value: '년도선택' },
                        { key: '2024', value: '2024' },
                        { key: '2023', value: '2023' },
                        { key: '2022', value: '2022' },
                        { key: '2021', value: '2021' },
                    ]}
                    btnStyle={{ marginRight: 16 }}
                    width={128}
                    value={year}
                    onItemClick={(val) => { setYear(val); setType('quarter') }}
                />
                <RadioButtonGroup
                    radioStyle={{ marginBottom: 0, marginRight: 16 }}
                    id='quarter'
                    value={quarter}
                    onChange={(value) => { handleQuarter(Number(value)); setType('quarter'); }}
                    options={[
                        { label: '1분기', value: 1 },
                        { label: '2분기', value: 2 },
                        { label: '3분기', value: 3 },
                        { label: '4분기', value: 4 }
                    ]}
                    containerStyle={{ justifyContent: 'flex-start' }}
                />
            </div>
        )
    }

    //최근 일자 선택 Render
    const renderRecent = () => {
        return (
            <div className="row" style={{ marginLeft: 24 }}>
                <RadioButtonGroup
                    radioStyle={{ marginBottom: 0, marginRight: 16 }}
                    id='recent'
                    value={recent}
                    onChange={(val) => { setRecent(Number(val)); setType('recent') }}
                    options={[
                        { label: '이번 달', value: 0 },
                        { label: '지난 달', value: 1 },
                        { label: '지난 1개월', value: 2 },
                        { label: '지난 3개월', value: 3 },
                        { label: '지난 6개월', value: 4 },
                    ]}
                />
            </div>
        )
    }

    return (
        <div className="vat">
            <p className="title">부가세 신고내역</p>
            <p className="warn-soldout">* 커머스 쿠폰 관련 부가세 자료는 취합 중 이여서 제공되지 않으니 따로 요청 부탁드립니다.</p>

            <p className="sub-title">기간 필터 선택</p>

            <div className="filter-table">
                <div className="filter-row">
                    <p className="filter-title" style={{ color: type === 'manual' && '#f95f53' }}>
                        <Dropdown
                            options={[
                                { key: '날짜 직접 선택', value: 'manual' },
                                { key: '분기 선택', value: 'quarter' },
                                { key: '최근 일자 선택', value: 'recent' },
                            ]}
                            btnStyle={{ textAlign: 'center' }}
                            width={156}
                            value={typeList[type]}
                            onItemClick={(val) => { setType(val) }}
                            btnContainerStyle={{ justifyContent: 'center' }}
                        />
                    </p>
                    {
                        type === 'manual' ? renderDate() : type === 'quarter' ? renderQuarter() : renderRecent()
                    }
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button variant="main" style={{ width: 156, fontSize: 16, marginTop: 72, marginBottom: 56 }} onClick={search}>
                    검색하기
                </Button>
            </div>

            <p className="sub-title">매출</p>

            <table>
                <tbody>
                    <tr>
                        <th>매출구분</th>
                        <th>매출</th>
                        <th>부가세</th>
                        <th>합계</th>
                    </tr>
                    <tr>
                        <td>카드매출</td>
                        <td>{convertCost(Math.floor(vat / 1.1))}</td>
                        <td>{convertCost(vat - Math.floor(vat / 1.1))}</td>
                        <td style={{ fontSize: 18, fontWeight: 'bold', lineHeight: 1.78, color: '#3f3f3f' }}>{convertCost(typeof vat === 'undefined' ? 0 : vat)}</td>
                    </tr>
                </tbody>
            </table>

            {/* <div className="vat-row">
                <button className="vat-btn" style={{ marginRight : 16 }}>
                    <div className="row">
                        <img src={require('../../aseets/icons/print.svg').default} style={{ width : 24, height : 24, marginRight : 15}}></img>
                        인쇄
                    </div>
                </button>

                <button className="vat-btn">
                    <div className="row">
                        <img src={require('../../aseets/icons/plus_gray.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}></img>
                        상세내역 다운로드
                    </div>
                </button>
            </div> */}
        </div>
    )
}

export default Vat;